import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import { FormattedMessage } from 'react-intl';
// utils
import moment from 'moment';
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { formatDateForUser } from 'utils/regionalDateHelper';

const toMoment = (date) => (moment.isMoment(date) ? date : moment(date, 'YYYY-MM-DD'));

// Effective date range of a treatment protocol: which newly placed groups inherit it. Told by its state
// today: an upcoming range by its start, a running one by its end, a past one by when it ended.
const EffectiveDates = ({ startDate, endDate, countryCode, className }) => {
  const today = moment().startOf('day');
  const format = (date) => formatDateForUser(date, countryCode);
  const message = (id, date) => <FormattedMessage id={id} values={{ date: format(date) }} />;

  const renderLabel = () => {
    if (endDate && toMoment(endDate).isBefore(today, 'day')) {
      return message('general.effectiveDates.ended', endDate);
    }
    if (startDate && toMoment(startDate).isAfter(today, 'day')) {
      return (
        <>
          {message('general.effectiveDates.starts', startDate)}
          {endDate && <> · {message('general.effectiveDates.ends', endDate)}</>}
        </>
      );
    }
    if (endDate) return message('general.effectiveDates.ends', endDate);

    return <FormattedMessage id="general.effectiveDates.noEndDate" />;
  };

  return <span className={className}>{renderLabel()}</span>;
};

EffectiveDates.propTypes = {
  startDate: T.oneOfType([T.string, T.object]),
  endDate: T.oneOfType([T.string, T.object]),
  countryCode: T.string,
  className: T.string,
};

export default connect((state) => ({
  countryCode: getCurrentCountryCode(state),
}))(EffectiveDates);
